/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RescheduleAppointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from '../helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function RescheduleAppointment({
  children,
  viewPath = "/DesignSystem/AppointmentActions/RescheduleAppointment"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentActionsAppointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'appointment_actions',
path: 'appointment_booking.state',
})
let constantData = 'NO_SHOW'
let constantData1 = 'PATIENT_CANCELLED'
let constantData2 = 'OFFICE_CANCELLED'
let aggregateData = fromHelpers.shouldShow(appointmentActionsAppointmentBookingStateValueData, constantData, constantData1, constantData2)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}